module.exports = __webpack_public_path__ + "4589c6a0f49064b289e3c01a96f38f17.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/clear.svg
// module id = 487
// module chunks = 65